import { ITableRow } from '@makyoapp/makyo-sdk/models/Table'

import { workerRequest } from '@/workers/worker-request'

import { IDBTable } from '../table'

export async function searchData(search: string | undefined, table: IDBTable, rows: ITableRow[]): Promise<ITableRow[]> {
  const { dataWorker } = table.dbClient

  if (!search?.trim().length) return Promise.resolve(rows)

  try {
    const response = await workerRequest<{ rows: ITableRow[] }>(dataWorker, {
      type: 'table-data-search',
      data: { search, rows },
    })
    
    return response.rows
    //
  } catch (err) {
    console.error('table-data-search error: ', err)
    return Promise.resolve(rows)
  }
}
